import { internalDropdowns } from '@/entities/dropdowns/models/InternalDropdowns'
import { groupsSelectors } from '@/entities/groups'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

type UpdateActiveGroupPayload = {
  groupId: number
}

type UpdateActiveGroupResult = {
  groupId: number
  timezoneOffset: string | null
}

export const updateActiveGroup = createAsyncThunk<UpdateActiveGroupResult, UpdateActiveGroupPayload, ThunkApiContext>('userInferface/updateActiveGroup', async ({ groupId }, { getState }) => {
  const state = getState()
  const allTimeZones = internalDropdowns.timeZones
  const group = groupsSelectors.selectById(state, groupId)
  const timeZone = allTimeZones.find((tz) => tz.value === group?.timeZone)

  return {
    groupId,
    timezoneOffset: timeZone?.offset || null,
  }
})
